import { useCallback } from 'react';
import { pick } from 'ramda';
import { isMirrorModeElement } from 'js/utils/DOM.util';

import * as helpers from './helpers';
import { pxToPercents } from '../../helpers';
import * as actions from '../../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../../store';

export const useHandleSwipe = (container: HTMLDivElement | null) => {
    const dispatch = useDynamicReducerDispatch();
    const {
        activeSlide, itemWidth, containerShift, slidesCount,
        config: { itemsPerView, loop, gap }
    } = useDynamicReducerSelector(pick([
        'activeSlide', 'itemWidth', 'containerShift', 'slidesCount', 'config'
    ]));

    return useCallback((swipeDeltaX: number, prevSwipeDeltaX: number) => {
        if (!container) {
            return;
        }

        const isMirrorMode = isMirrorModeElement(container);

        if (swipeDeltaX) {
            const diff = pxToPercents(container, swipeDeltaX) * (isMirrorMode ? 1 : 1);

            container.style.setProperty('transform', `translateX(${containerShift - diff}%)`);

            return;
        }

        // on swipe end
        const isSwipeDenied = helpers.isSwipeDenied({
            swipeDeltaX: prevSwipeDeltaX, itemsPerView,
            loop, activeSlide, slidesCount, isMirrorMode
        });

        if (isSwipeDenied || Math.abs(prevSwipeDeltaX) < itemWidth / 3) {
            container.classList.add('animating');
            container.style.setProperty('transform', `translateX(${containerShift}%)`);

            return;
        }

        const toRight = isMirrorMode ? prevSwipeDeltaX < 0 : prevSwipeDeltaX > 0;
        const diff = Math.ceil(Math.abs(prevSwipeDeltaX) / (itemWidth + gap));

        if (toRight) {
            dispatch(actions.moveRight(diff));
        } else {
            dispatch(actions.moveLeft(diff));
        }
    }, [container, dispatch, activeSlide, itemWidth, containerShift, slidesCount, itemsPerView, loop, gap]);
};
